(function ($) {
	if (!window.TOOLTIP_URL) {
		return;
	}

	const $glossaryLinks = $(`a[href^="${window.TOOLTIP_URL}"]:not(.tooltip)`);

	// each $glossaryLinks replace it with a <span>
	$glossaryLinks.each(function () {
		const $this = $(this);
		const $span = $('<button>', {
			class: 'tooltip',
			html: $this.html(),
			'data-href': $this.attr('href'),
		});

		$this.replaceWith($span);
	});

	// const $glossaryLinks = $(`a[data-type="glossary-terms"]:not(.tooltip)`);
	if (!$glossaryLinks.length) {
		return;
	}

	let isTouchDevice = false;

	$glossaryLinks.on('touchstart', function () {
		isTouchDevice = true;
	});

	$glossaryLinks.on('click', function (e) {
		if (!this._tippy.state.isShown && isTouchDevice) {
			e.preventDefault();
		}
	});

	tippy('.tooltip', {
		touch: true,
		// trigger: 'mouseenter click touchstart',
		trigger: 'mouseenter click touchstart',
		interactive: true,
		aria: {
			content: 'describedby',
		},
		allowHTML: true,
		onCreate(instance) {
			// Setup our own custom state properties
			instance._isFetching = false;
			instance.setContent('Loading...');
		},
		onShow(instance) {
			if (instance._isFetching) {
				return;
			}

			instance._isFetching = true;

			const $ref = $(instance.reference);

			const url = $ref.attr('data-href');
			let content = 'Could not find definition';

			$.get(url, function AjaxCall(res) {
				const $html = $(res);
				const $definition = $html;

				if ($definition.length) {
					content = $definition.html();
				}

				instance.setContent(content);
			});
		},
	});
})(jQuery);
